<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image hospitality-splash" v-if="!isMobile()">
                                        <img alt="Hospitality" src="./assets/hospitality-splash.svg">
                                    </figure>
                                    <figure class="image hospitality-splash mobile-screen" v-else>
                                        <img alt="Hospitality" src="./assets/hospitality-splash.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-1x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('hospitality:hospitality.title') }}
                                </h1>
                            </div>
                            <div class="columns is-centered">
                                <h2 class="is-size-5 has-text-centered-mobile uptin-text-center small-container">
                                    {{ $t('hospitality:hospitality.subtitle') }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- First section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('hospitality:hospitality.first_title_up')">
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                     <div class="column content column-center">
                        <figure class="image img-500" v-if="!isMobile()">
                            <img alt="Value Proposition" src="./assets/hospitality-section1.svg">
                        </figure>
                        <figure class="image img-400 mobile-screen" v-else>
                            <img alt="Value Proposition" src="./assets/hospitality-section1.svg">
                        </figure>
                     </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('hospitality:hospitality.first_description1') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('hospitality:hospitality.first_description2') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Second section -->
        <section class="section">
            <div class="columns">
                <!-- Column 1 -->
                <div class="column has-padding-2x">
                    <div class="has-padding-2x">
                        <div class="column intro-text content">
                            <h3 class="is-size-5 small-container padding-bottom-1x uptin-text-center"
                                v-html="$t('hospitality:hospitality.second_col1_title')">
                            </h3>
                        </div>

                        <div class="column intro-text content small-container is-paddingless">
                            <p class="justify-text is-size-6 small-container uptin-text-center uptin-text-7">
                                {{ $t('hospitality:hospitality.second_col1_description') }}
                            </p>
                        </div>

                        <div class="column content column-center is-centered-container">
                            <figure class="image img-200" v-if="!isMobile()">
                                <img alt="Fast and easy" src="./assets/hospitality-section21.svg">
                            </figure>
                            <figure class="image img-200 mobile-screen" v-else>
                                <img alt="Fast and easy" src="./assets/hospitality-section21.svg">
                            </figure>
                        </div>
                    </div>
                </div>

                <!-- Column 2 -->
                <div class="column has-padding-2x">
                    <div class="has-padding-2x">
                        <div class="column intro-text content">
                            <h3 class="is-size-5 small-container padding-bottom-1x uptin-text-center"
                                v-html="$t('hospitality:hospitality.second_col2_title')">
                            </h3>
                        </div>

                        <div class="column intro-text content small-container is-paddingless">
                            <p class="justify-text is-size-6 small-container uptin-text-center uptin-text-7">
                                {{ $t('hospitality:hospitality.second_col2_description') }}
                            </p>
                        </div>

                        <div class="column content column-center is-centered-container">
                            <figure class="image img-200" v-if="!isMobile()">
                                <img alt="Save money" src="./assets/hospitality-section22.svg">
                            </figure>
                            <figure class="image img-200 mobile-screen" v-else>
                                <img alt="Save money" src="./assets/hospitality-section22.svg">
                            </figure>
                        </div>
                    </div>
                </div>

                <!-- Column 3 -->
                <div class="column has-padding-2x">
                    <div class="has-padding-2x">
                        <div class="column intro-text content">
                            <h3 class="is-size-5 small-container padding-bottom-1x uptin-text-center"
                                v-html="$t('hospitality:hospitality.second_col3_title')">
                            </h3>
                        </div>

                        <div class="column intro-text content small-container is-paddingless">
                            <p class="justify-text is-size-6 small-container uptin-text-center uptin-text-7">
                                {{ $t('hospitality:hospitality.second_col3_description') }}
                            </p>
                        </div>

                        <div class="column content column-center is-centered-container">
                            <figure class="image img-200" v-if="!isMobile()">
                                <img alt="User experience" src="./assets/hospitality-section23.svg">
                            </figure>
                            <figure class="image img-200 mobile-screen" v-else>
                                <img alt="User experience" src="./assets/hospitality-section23.svg">
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Third section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('hospitality:hospitality.third_title_up')">
                        </h3>
                    </div>
                </div>


                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center uptin-text-7 text-white">
                            {{ $t('hospitality:hospitality.third_description1') }}
                        </p>
                    </div>
                </div>

                <div class="columns has-padding-2x">
                    <div class="column intro-text content small-container">
                        <table class="table" style="background: transparent; direction: rtl; margin: 0;">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="uptin-text-center uptin-text-center text-white">{{ $t('hospitality:hospitality.table_head1') }}</th>
                                    <th class="uptin-text-center uptin-text-center text-white">{{ $t('hospitality:hospitality.table_head2') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature1') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature2') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-red">{{ $t('hospitality:hospitality.doesnt') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature3') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-red">{{ $t('hospitality:hospitality.doesnt') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature4') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-red">{{ $t('hospitality:hospitality.doesnt') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature5') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature6') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-red">{{ $t('hospitality:hospitality.doesnt') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature7') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature8') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.does') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-red">{{ $t('hospitality:hospitality.doesnt') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature9') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.doesnt') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-red">{{ $t('hospitality:hospitality.high') }}</td>
                                </tr>
                                <tr>
                                    <td class=" uptin-text-center text-white">{{ $t('hospitality:hospitality.feature10') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-green">{{ $t('hospitality:hospitality.low') }}</td>
                                    <td class="uptin-text-center uptin-text-center text-red">{{ $t('hospitality:hospitality.high') }}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

        <!-- Forth section-->
        <section class="section is-background-yellow">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center"
                            v-html="$t('hospitality:hospitality.forth_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column intro-text content small-container">
                        <p class="small-container uptin-text-center uptin-text-center">
                            {{ $t('hospitality:hospitality.forth_description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-1x uptin-text-center">
                        <a href="https://panel.uptinptt.ir/signup" class="button uptin-splash-button is-background-dark1 text-white" active-class="is-active is-active--advertiser">
                            {{ $t('hospitality:hospitality.forth_button') }}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
    .hospitality-splash {
        max-width: 450px;
        min-width: 450px;
        margin: 2%;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>
    export default {
        components: {
        },
        name: 'hospitality',
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        }
    }
</script>
